import { PAGE_LINKS } from '@/helpers/commonConsts'
import Loadable from '@/router/loadable'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const HomePage = Loadable(lazy(() => import('@/pages/mobile/HomePage/HomePage')))
const MobileTabLayout = Loadable(
  lazy(() => import('@/pages/mobile/MobileTabLayout/MobileTabLayout'))
)
const SearchPage = Loadable(lazy(() => import('@/pages/mobile/SearchPage/SearchPage')))
const BuyRecommendPage = Loadable(lazy(() => import('@/pages/mobile/BuyRecommendPage/BuyRecommendPage')))
const GoodsDetailPage = Loadable(lazy(() => import('@/pages/mobile/GoodsDetailPage/GoodsDetailPage')))
const WxLoginPage = Loadable(lazy(() => import('@/pages/mobile/WxLoginPage/WxLoginPage')))
const WxPayPage = Loadable(lazy(() => import('@/pages/mobile/WxPayPage/WxPayPage')))
const MobileOrderPage = Loadable(lazy(() => import('@/pages/mobile/MobileOrder/MobileOrderPage')))
const PersonalCenter = Loadable(lazy(() => import('@/pages/mobile/PersonalCenter/PersonalCenter')))
const MobilePursced = Loadable(lazy(() => import('@/pages/mobile/MobilePursced')))
const MobileCoupons = Loadable(lazy(() => import('@/pages/mobile/MobileCoupons/MobileCouponsPage')))
const MobileCouponClaim = Loadable(lazy(() => import('@/pages/mobile/MobileCouponClaim/MobileCouponClaimPage')))

const mobileRoutes: RouteObject[] = [
  {
    element: <MobileTabLayout />,
    children: [
      {
        path: PAGE_LINKS.home,
        element: <HomePage />,
      },
      {
        path: PAGE_LINKS.personalCenter,
        element: <PersonalCenter />,
      },
    ],
  },
  {
    path: PAGE_LINKS.goodsDetail,
    element: <GoodsDetailPage />,
  },
  {
    path: PAGE_LINKS.wxPay,
    element: <WxPayPage />,
  },
  {
    path: `${PAGE_LINKS.search}/:searchText`,
    element: <SearchPage />,
  },
  {
    path: `${PAGE_LINKS.buyRecommend}`,
    element: <BuyRecommendPage />,
  },
  {
    path: PAGE_LINKS.wxLogin,
    element: <WxLoginPage />,
  },
  {
    path: PAGE_LINKS.mobileOrder,
    element: <MobileOrderPage />,
  },
  {
    path: PAGE_LINKS.mobilePurshed,
    element: <MobilePursced />,
  },
  {
    path: PAGE_LINKS.mobileCoupons,
    element: <MobileCoupons />,
  },
  {
    path: PAGE_LINKS.mobileCouponClaim,
    element: <MobileCouponClaim />,
  },
]

export default mobileRoutes
